// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_e8ce0c', '__Inter_Fallback_e8ce0c'","fontStyle":"normal"},"className":"__className_e8ce0c","variable":"__variable_e8ce0c"};